// Structured condition summary for a spam rule -- extracted to its own file
// (rather than inline in SpamRulesView.jsx) purely so it's unit-testable:
// this project's plain `node --test` runner has no JSX transform, so a .jsx
// file can never be imported from a node:test file even for a JSX-free
// helper function defined inside it. Mirrors spamRuleSearch.js's style.
//
// Returns structured data, not JSX -- SpamRulesView.jsx's Conditions column
// renders `lines` as labeled text lines and `fromPhrases`/`subjectPhrases`
// each as their own chip list, alphabetically sorted so a rule with many
// values (the AM Website "Auto Reply" rule ported from Bright Pattern's
// IVR, 10+ phrases) is scannable instead of one long "or"-chained sentence.
export function buildConditionSummary(rule) {
  const lines = []
  if (rule.toPattern) lines.push({ label: 'To', text: `contains "${rule.toPattern}"` })
  if (rule.bodyPattern) {
    const qualifier = rule.bodyPatternType === 'wildcard' ? 'wildcard' : 'contains'
    lines.push({ label: 'Body', text: `${qualifier} "${rule.bodyPattern}"` })
  }
  if (rule.intent) lines.push({ label: 'Intent', text: rule.intent })
  const fromPhrases = rule.fromPatterns?.length
    ? [...rule.fromPatterns].sort((a, b) => a.localeCompare(b))
    : []
  const subjectPhrases = rule.subjectPatterns?.length
    ? [...rule.subjectPatterns].sort((a, b) => a.localeCompare(b))
    : []
  return { lines, fromPhrases, subjectPhrases }
}
